<template>
  <div class="admin-page">
    <h2>Поездки</h2>

    <p v-if="error" class="error-message">{{ error }}</p>

    <div class="panel">
      <p v-if="loading" class="empty-text">Загрузка...</p>
      <p v-else-if="trips.length === 0" class="empty-text">Поездок нет.</p>

      <div v-else class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Название</th>
              <th>Автор</th>
              <th>Публичная</th>
              <th>Архив</th>
              <th>Дата поездки</th>
              <th>Создана</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="trip in trips" :key="trip.id">
              <td data-label="Название">
                <router-link :to="{ name: 'trip', params: { id: trip.id } }">
                  {{ trip.name }}
                </router-link>
              </td>
              <td data-label="Автор">{{ trip.user?.display_name || `Пользователь #${trip.user_id}` }}</td>
              <td data-label="Публичная">{{ trip.public ? 'Да' : 'Нет' }}</td>
              <td data-label="Архив">
                <span v-if="trip.archived">Да, {{ formatDateTime(trip.archived_at) }}</span>
                <span v-else>Нет</span>
              </td>
              <td data-label="Дата поездки">{{ trip.trip_date || '—' }}</td>
              <td data-label="Создана">{{ formatDateTime(trip.created_at) }}</td>
              <td data-label="Действия">
                <div class="btn-row admin-actions">
                  <button
                    v-if="!trip.archived"
                    type="button"
                    class="btn btn-secondary btn-sm"
                    :disabled="busyId === trip.id"
                    @click="archiveTrip(trip)"
                  >
                    В архив
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    :disabled="busyId === trip.id"
                    @click="removeTrip(trip)"
                  >
                    Удалить
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { archiveAdminTrip, destroyAdminTrip, fetchAdminTrips } from '../../api/admin'
import { extractApiError } from '../../utils/apiError'
import { formatDateTime } from '../../utils/formatDateTime'

const trips = ref([])
const loading = ref(true)
const error = ref('')
const busyId = ref(null)

async function loadTrips() {
  loading.value = true
  error.value = ''
  try {
    trips.value = await fetchAdminTrips()
  } catch (err) {
    error.value = extractApiError(err, 'Не удалось загрузить поездки')
  } finally {
    loading.value = false
  }
}

function updateTrip(updated) {
  trips.value = trips.value.map((item) => (item.id === updated.id ? updated : item))
}

async function runAction(trip, action) {
  busyId.value = trip.id
  error.value = ''
  try {
    await action()
  } catch (err) {
    error.value = extractApiError(err)
  } finally {
    busyId.value = null
  }
}

async function archiveTrip(trip) {
  if (!window.confirm(`Отправить поездку «${trip.name}» в архив?`)) return
  await runAction(trip, async () => {
    const updated = await archiveAdminTrip(trip.id)
    updateTrip(updated)
  })
}

async function removeTrip(trip) {
  if (!window.confirm(`Удалить поездку «${trip.name}»? Это необратимо.`)) return
  await runAction(trip, async () => {
    await destroyAdminTrip(trip.id)
    trips.value = trips.value.filter((item) => item.id !== trip.id)
  })
}

onMounted(loadTrips)
</script>
